import { AiChatView } from '@euler/app/flows/ai-suite/chat/AiChatView';
import {
  AiChatConversation,
  AiChatState,
  AiChatTap,
} from '@euler/app/flows/ai-suite/conversation';
import { AiSuiteTool, aiColors } from '@euler/app/flows/ai-suite/theme';
import { ChevronDown, X } from 'lucide-react-native';
import { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Observable } from 'rxjs';

/** How wide the chat is when it sits beside its page. */
export const kBiChatPanelWidth = 420;

/**
 * A BI page's chat (a dashboard's, a dataset's): a column beside the page
 * where there is room (desktop web, iPad landscape), a full-screen layer
 * over it otherwise. Hidden, it stays mounted: a dashboard's pending change
 * card keeps drawing the preview, which is what closing the layer is for.
 */
export const DashboardChatPanel = memo(
  ({
    tool,
    side,
    visible,
    conversation,
    state,
    tapSettled$,
    onClose,
  }: {
    /** The chat's chip, empty state and composer hint. */
    tool: AiSuiteTool;
    side: boolean;
    visible: boolean;
    conversation: AiChatConversation;
    state: AiChatState;
    /** The conversation's taps, once the page has read itself again. */
    tapSettled$: Observable<AiChatTap>;
    onClose: () => void;
  }) => {
    const chat = (
      <AiChatView
        state={state}
        tool={tool}
        showBack
        backIcon={side ? X : ChevronDown}
        onBack={onClose}
        onSend={(text, attachments, tap) =>
          conversation.send(text, attachments, tap)
        }
        onStop={() => conversation.stop()}
        onRetry={() => conversation.retry()}
        onReact={(key, reaction) => conversation.react(key, reaction)}
        onEarlier={() => void conversation.earlier()}
        checklist={null}
        settled={null}
        campaign={null}
        tapSettled$={tapSettled$}
      />
    );
    return (
      <View
        style={[
          side
            ? {
                width: kBiChatPanelWidth,
                borderLeftWidth: 1,
                borderLeftColor: aiColors.border,
              }
            : StyleSheet.absoluteFill,
          { backgroundColor: aiColors.card },
          !visible && { display: 'none' },
        ]}
      >
        {chat}
      </View>
    );
  },
);
